import React, { useContext, useEffect, useState } from 'react';
import { SignalRContext } from '../../../../context/signalR';
import { IChat, IChatDating, SendMessagePayload } from '../../../../types/chat';
import { HubEvent } from '../../../../enums/hubnames';
import ListFriendChatDating from './chatDatingComponent/listFrientChatDating';
import ChatDetailDating from './chatDatingComponent/ChatDetailDating';
import {
  IFriendDating,
  useDating,
} from '../../../../hooks/use-dating/useDating';
import { useNavigate } from 'react-router-dom';

export const ChatPageDating = () => {
  const {
    state: { connectionDating },
  } = useContext(SignalRContext);
  const [currentChat, setCurrentChat] = useState<IFriendDating | null>(null);
  const [newMessage, setNewMessage] = useState<IChatDating | null>(null);
  const [listNewMessage, setListNewMessage] = useState<IChatDating[]>([]);
  const { friendsDating } = useDating({ pageSize: 100 });
  const handleSendMessage = (payload: SendMessagePayload) => {
    connectionDating?.invoke('SendDatingMessage', payload);
  };
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const profileId = params.get('id');

    if (profileId && friendsDating.length > 0) {
      const defaultUser = friendsDating.find(
        (friend) => friend.profileId === profileId
      );
      if (defaultUser) {
        setCurrentChat(defaultUser);
      }
    }
  }, [location.search, friendsDating]);

  useEffect(() => {
    connectionDating?.on(HubEvent.NewMessageDating, (message: IChatDating) => {
      setNewMessage(message);
      setListNewMessage([message]);
      setListNewMessage((prev) => {
        if (newMessage) {
          return [newMessage, ...(prev ?? [])];
        }

        return prev;
      });
    });
  }, [connectionDating]);

  return (
    <div className=" relative overflow-hidden dark:border-slate-700">
      <div className="flex bg-white dark:bg-dark2">
        <ListFriendChatDating
          onSelect={(friend) => {
            const params = new URLSearchParams(location.search);
            params.set('id', friend.profileId);
            navigate(`?${params.toString()}`, { replace: true });
            setCurrentChat(friend);
          }}
          currentChat={currentChat}
          listNewMessage={listNewMessage}
        />

        <div className="flex-1 h-[calc(100vh-76px)]  px-6 py-6">
          {currentChat ? (
            <div className="border h-full rounded-lg">
              <ChatDetailDating
                user={currentChat}
                handleSendMessage={handleSendMessage}
                newMessage={newMessage}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center mt-10">
              <p className="text-sm text-slate-800 dark:text-slate-50">
                Chọn người để bắt đầu cuộc trò chuyện
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
